/**
 * Presentation meta for the ad funnel stages (funnel-stage-presentation spec). Short labels fit
 * the narrow KPI grid cells (the full label wraps there); full labels put the marketer term
 * first with plain language second; definitions mirror the extraction criteria (the
 * `AdFunnelStage` schema docs) so every tooltip explains the same thing the classifier judged.
 */
export const FUNNEL_STAGE_META: Record<string, { short: string; label: string; definition: string }> = {
    TOFU: {
        short: 'TOFU',
        label: 'TOFU · Awareness',
        definition:
            'Top of funnel — brand-led and aspirational, little or no product detail, soft or absent call to action.',
    },
    MOFU: {
        short: 'MOFU',
        label: 'MOFU · Consideration',
        definition:
            'Mid funnel — product or solution centric: feature callouts, comparisons, proof, demos.',
    },
    BOFU: {
        short: 'BOFU',
        label: 'BOFU · Conversion',
        definition:
            'Bottom of funnel — dense offer signals: price, discount, urgency, a direct buy or book action.',
    },
}

/** Canonical stage order for bars and legends: the funnel reads top to bottom. */
export const FUNNEL_STAGE_ORDER = ['TOFU', 'MOFU', 'BOFU'] as const
